<div class="upload-content">
    <div class="file-preview">
      <div class="file-icon" [ngStyle]="{ 'background-color': getFileBackgroundColor() }">
        <img [src]="getFileIcon()" alt="File Icon" class="file-icon-img"/>
      </div>
      <div class="file-details">
        <div class="file-name">{{ file.name }}</div>
        <div class="file-type">{{ getFileType() }}</div>
      </div>
    </div>
    <button *ngIf="showRemoveButton" class="remove-file-btn" (click)="onRemoveFile()">
      <img src="assets/custom-icons/close.svg" alt="Remove" class="close-icon"/>
    </button>    
</div>
